document.addEventListener('DOMContentLoaded', function () {
  initIconCardsSwiper();
});

function initIconCardsSwiper() {
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper library not loaded. Icon cards will render as a grid.');
    return;
  }

  const sections = document.querySelectorAll('.iconCardsSection');

  sections.forEach((section) => {
    const swiperContainer = section.querySelector('.iconCardsSection_swiper');
    const paginationEl = section.querySelector('.iconCardsSection_pagination');

    if (!swiperContainer || !swiperContainer.querySelector('.swiper-wrapper')) return;

    let swiperInstance = null;
    const mediaQuery = window.matchMedia('(max-width: 1024px)');

    const enableSwiper = () => {
      if (swiperInstance) return;
      try {
        swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: paginationEl,
            type: 'bullets',
            clickable: true,
          },
        });
      } catch (error) {
        console.error('Error initializing Swiper:', error);
      }
    };

    const disableSwiper = () => {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const handleBreakpoint = () => {
      if (mediaQuery.matches) {
        enableSwiper();
      } else {
        disableSwiper();
      }
    };

    handleBreakpoint();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleBreakpoint);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleBreakpoint);
    }
  });
}
